<footer>
	<div class="container">
		{{'FOOTER_TEXT' | translate}}
		<p><a href="#">{{'FOOTER_SUBTEXT' | translate}}</a></p>
	</div>
</footer>
